var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content-wrappper reg-home" },
    [
      _c("regulatory-update-header", {
        attrs: {
          permissions: _vm.permissions,
          headerValues: _vm.headerValues,
          searchRegulatoryText: _vm.searchRegulatory,
          isFromGlobalSearch: _vm.isFromGlobalSearch,
        },
        on: { filterSearchRegulatory: _vm.filterSearchRegulatory },
      }),
      _c("div", { staticClass: "body" }, [
        _c(
          "div",
          { staticClass: "regulatory-alert-updates p-relative" },
          [
            _vm.permissions.includes("REG_WTCH_REG_UPD_FILTER")
              ? _c("shared-left-filter", {
                  attrs: {
                    chevronList: _vm.chevronList,
                    expectedFilter: _vm.resultingFilter,
                    countriesList: _vm.countriesList,
                    dateFormat: _vm.dateFormat,
                    permissions: _vm.permissions,
                    types: _vm.types,
                    isRegWatch: true,
                  },
                  on: { setFilter: _vm.setFilterOptions },
                })
              : _vm._e(),
            _c(
              "div",
              { staticClass: "reg-update-tabs col-xs-12 p-0 xs-pt-15" },
              [
                [
                  _c(
                    "ul",
                    { staticClass: "horizontal-tabs d-flex p-0 mt-10" },
                    [
                      _vm.permissions.includes("REG_WTCH_REG_UPD_NEW")
                        ? _c(
                            "li",
                            {
                              staticClass: "cursor-pointer",
                              class: { active: _vm.activeName === "new" },
                              on: {
                                click: function ($event) {
                                  return _vm.setTab("new")
                                },
                              },
                            },
                            [
                              _vm._v(
                                " New (" +
                                  _vm._s(_vm.headerValues.newCount) +
                                  ") "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.permissions.includes("REG_WTCH_REG_UPD_VIEW_ALL")
                        ? _c(
                            "li",
                            {
                              staticClass: "cursor-pointer",
                              class: { active: _vm.activeName === "viewAll" },
                              on: {
                                click: function ($event) {
                                  return _vm.setTab("viewAll")
                                },
                              },
                            },
                            [
                              _vm._v(
                                " View All (" +
                                  _vm._s(_vm.headerValues.viewAllCount) +
                                  ") "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.permissions.includes("REG_WTCH_REG_UPD_COVID_19")
                        ? _c(
                            "li",
                            {
                              staticClass: "cursor-pointer",
                              class: { active: _vm.activeName === "covid19" },
                              on: {
                                click: function ($event) {
                                  return _vm.setTab("covid19")
                                },
                              },
                            },
                            [
                              _vm._v(
                                " COVID-19 (" +
                                  _vm._s(_vm.headerValues.covid19Count) +
                                  ") "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.permissions.includes("REG_WTCH_REG_UPD_FLAGGED")
                        ? _c(
                            "li",
                            {
                              staticClass: "cursor-pointer",
                              class: { active: _vm.activeName === "flag" },
                              on: {
                                click: function ($event) {
                                  return _vm.setTab("flag")
                                },
                              },
                            },
                            [
                              _vm._v(
                                " Flagged (" +
                                  _vm._s(_vm.headerValues.flaggedCount) +
                                  ") "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm.permissions.includes("REG_WTCH_REG_UPD_ARCHIVE")
                        ? _c(
                            "li",
                            {
                              staticClass: "cursor-pointer",
                              class: { active: _vm.activeName === "archive" },
                              on: {
                                click: function ($event) {
                                  return _vm.setTab("archive")
                                },
                              },
                            },
                            [
                              _vm._v(
                                " Archive (" +
                                  _vm._s(_vm.headerValues.archiveCount) +
                                  ") "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                ],
              ],
              2
            ),
            _c("regulatory-update-container", {
              attrs: {
                permissions: _vm.permissions,
                filterCollapse: _vm.filterCollapse,
                selectedMenu: _vm.selectedMenu,
                regulatoryUpdateList: _vm.regulatoryUpdateList,
                searchRegulatory: _vm.searchRegulatory,
                isFromGlobalSearch: _vm.isFromGlobalSearch,
                globalSearchFilteredData: _vm.globalSearchFilteredData,
              },
              on: {
                updateFlag: _vm.markRegUpdateAsFlagged,
                deleteRegulatoryFromNew: _vm.deleteRegulatoryFromNew,
                archiveRegulatory: _vm.archiveRegulatory,
                unArchiveRegulatory: _vm.unArchiveRegulatory,
              },
            }),
          ],
          1
        ),
      ]),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
      _c("unsubscribed-country-popup", {
        attrs: {
          id: "modal_unsubscribed_country",
          isCountryNotSubscribed: true,
        },
        on: {
          setGlobalSearch: function ($event) {
            _vm.isFromGlobalSearch = false
          },
          regWatchInAccountSettings: _vm.OpenRegWatchSettings,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }